import { t } from '@/locales'
import type { TLabAdminRole } from '@team-milva/lab-models/user'

export function getMainRoleDisplayName(role: TLabAdminRole): string {
  switch (role) {
    case 'admin':
      return t('role.admin')
    case 'customer-success':
      return t('role.customer-success')
    default:
      return t('role.none')
  }
}

